// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"245":"component---src-pages-index-tsx","407":"95b64a6e","453":"d7eeaac4","673":"98ea7ec2"}[chunkId] + "-" + {"245":"46802cd09272f5a5a733","407":"614eee0d4a5ceff5201c","453":"1aba310443e5fbdc2037","673":"fad7baaedaf7ce8f49b0"}[chunkId] + ".js";
};